export const products = [
  {
    id: 1,
    title: "Shoptronics",
    img: "https://i.ibb.co/88x7k92/screencapture-shoptronics-ninja-vercel-app-2022-11-26-22-56-15.png",
    img1: "https://i.ibb.co/4PCCXq9/screencapture-shoptronics-ninja-vercel-app-shop-2022-11-26-22-56-00.png",
    img2: "https://i.ibb.co/PhXWmZg/screencapture-shoptronics-ninja-vercel-app-product-apple-incredible-frozen-keyboard-2022-11-26-22-57.png",
    ft1: "Fullstack Ecommerce Application",
    ft2: "Payment Gateway Integration (Stripe and Cash on Delivery)",
    ft3: "Product Variations with Product Gallery",
    ft4: "User Authentication with Next Auth and GraphQL",
    ft5: "Pagination and Sorting with filtering products by properties",
    link: "https://shoptronics-ninja.vercel.app/",
    gitClient: "https://github.com/Safin-Ahmed/shoptronics-frontend",
    gitServer: "https://github.com/Safin-Ahmed/shoptronics-backend",
  },
  {
    id: 2,
    title: "Clean Youtube",
    img: "https://i.ibb.co/J5VWYNz/screencapture-clean-youtube-netlify-app-2022-11-26-22-52-15.png",
    img1: "https://i.ibb.co/gJbLv6W/screencapture-clean-youtube-netlify-app-playlist-PL-Xxu-Zq-N0x-VD0op-QDEgy-XFA4f-RPChvkl-2022-11-26.png",
    img2: "https://i.ibb.co/rdw2qyF/screencapture-clean-youtube-netlify-app-favorites-2022-11-26-22-53-32.png",
    ft1: "CRUD compatible course playlist player website (users can Create, Remove, Update, Delete) playlists",
    ft2: "Implemented cache system to cache all data of that playlist",
    ft3: "Implemented local storage to preserve added playlists",
    ft4: "Implemented note taking feature to take notes at different duration of the active video.",
    ft5: "Fetch Youtube API only if the playlist is not available in cache.",
    link: "https://clean-youtube.netlify.app/",
    gitClient: "https://github.com/Safin-Ahmed/clean-youtube",
  },
  {
    id: 3,
    title: "Track Zone",
    img: "https://i.ibb.co/zn2Vh7M/screencapture-track-zone-netlify-app-2022-11-26-23-13-47.png",
    img1: "https://i.ibb.co/WDTMnMC/screencapture-track-zone-netlify-app-2022-11-26-23-17-18.png",
    img2: "https://i.ibb.co/pzptHfB/screencapture-track-zone-netlify-app-2022-11-26-23-16-48.png",
    ft1: "Users can set their own time and timezone",
    ft2: "Users can create as many clocks as they want.",
    ft3: "Users can edit or delete a clock",
    ft4: "Timezone could be UTC (standard), GMT, PST, EST.",
    ft5: "Events can be created, updated and deleted from individual clock",
    link: "https://track-zone.netlify.app/",
    gitLink: "https://github.com/Safin-Ahmed/track-zone",
  },
  {
    id: 4,
    title: "Team Manager",
    img: "https://i.ibb.co/dPkHPsr/screencapture-teammanager-netlify-app-2022-11-26-23-08-09.png",
    img1: "https://i.ibb.co/WG8Z493/screencapture-teammanager-netlify-app-2022-11-26-23-09-15.png",
    img2: "https://i.ibb.co/QQqP16h/screencapture-teammanager-netlify-app-2022-11-26-23-10-43.png",
    ft1: "Users can create individual projects as many as they want",
    ft2: "Users can create as many tasks as they want under a project",
    ft3: "Users can nest sub tasks inside a task as deep as they want",
    ft4: "Users can create other users and assign them to a task. ",
    ft5: "Users can set a deadline for a task",
    link: "https://teammanager.netlify.app/",
    gitLink: "https://github.com/Safin-Ahmed/team-manager",
  },
  {
    id: 5,
    title: "Hoogtech",
    img: "https://i.ibb.co/MpfckLc/screencapture-hoogtech-58f30-web-app-2022-11-26-23-19-57.png",
    img1: "https://i.ibb.co/1z4L2MC/screencapture-hoogtech-58f30-web-app-explore-2022-11-26-23-21-31.png",
    img2: "https://i.ibb.co/p2fmFGP/screencapture-hoogtech-58f30-web-app-dashboard-2022-11-26-23-23-53.png",
    ft1: "CRUD Compatible Website (Users can Create, Remove, Update, Delete)",
    ft2: "Custom User Dashboard when logs in",
    ft3: "Fully Dynamic Website and JWT Token Implemented for Secured API",
    ft4: "Backend and Database Integrated Website",
    ft5: "100% Secured Firebase Authentication",
    link: "https://hoogtech-58f30.web.app/",
    gitClient: "https://github.com/Safin-Ahmed/hoogtech-client",
    gitServer: "https://github.com/Safin-Ahmed/hoogtech-server",
  },
  {
    id: 6,
    title: "Voyage Tourism Website",
    img: "https://i.ibb.co/WvQD7M3/screencapture-tourism-website-39175-web-app-2022-11-26-23-26-34.png",
    img1: "https://i.ibb.co/5L4wnWY/screencapture-tourism-website-39175-web-app-manage-Orders-2022-11-26-23-27-37.png",
    img2: "https://i.ibb.co/94nfg88/screencapture-tourism-website-39175-web-app-my-Order-2022-11-26-23-27-27.png",
    ft1: "CRUD Compatible Website (Users can Create, Remove, Update, Delete)",
    ft2: "Custom User Dashboard when logs in",
    ft3: "Fully Dynamic Website and JWT Token Implemented for Secured API",
    ft4: "Backend and Database Integrated Website",
    ft5: "100% Secured Firebase Authentication",
    link: "https://abbylabel.myshopify.com/",
  },
];
